import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

interface OutboundIpResponse {
  ip_address: string;
  source_service?: string;
  timestamp?: string;
  note?: string;
}

export const useOutboundIp = () => {
  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery<OutboundIpResponse, Error>(
    'outboundIp',
    async () => {
      const response = await apiClient.get('/api/v1/scraper/status/outbound-ip');
      return response.data;
    },
    {
      // Don't refetch too aggressively; IP should be relatively stable
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    outboundIp: data,
    isLoading,
    error,
    refetch,
  };
};

